import { Task } from '@/api';
import { createContext } from 'react';

export interface TaskContextData {
    task: Task | null;
    status: 'error' | 'success' | 'pending';
    refetch: () => void;
}

export const TaskContext = createContext<TaskContextData | undefined>(
    undefined
);
